import { cents as r } from "@systemeio/ui";
const n = (t, c) => r(t.price * (c ?? 0) / 100), a = (t, c) => {
  const e = n(t, c);
  return r(e + t.price);
};
export {
  n as calculateShippingTax,
  a as calculateShippingTotal
};
